import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const icon = css`
  margin-left: 0.5rem;
  margin-right: 0.25rem;
`;

export const menuItem = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const item = css`
  margin-right: 1.5rem;
  padding: 0.55rem 0.75rem;
  border-radius: 2rem;
  cursor: pointer;

  /* @media only screen and (min-width: ${dimensions.tablet}) {
    margin: 0;
    padding: 0;
    border-radius: 0;
  } */
`;

export const mobileItem = css`
  margin: 0;
`;

export const active = (theme: Theme) => css`
  background: ${theme.system.backgroundMuted};
`;

export const mobileActive = (theme: Theme) => css`
  color: ${theme.primary.textBase};
`;
